// src/components/pos/Cart.js
import React from 'react';
import { Box, Typography, List, ListItem, ListItemText, IconButton, Divider, Button, Alert } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

const Cart = ({ cart, setCart, onProceedToPayment, onOpenCreditModal, store }) => {
    const updateQuantity = (productId, amount) => {
        setCart(currentCart =>
            currentCart.map(item =>
                item.id === productId ? { ...item, quantity: item.quantity + amount } : item
            ).filter(item => item.quantity > 0)
        );
    };
    const total = cart.reduce((sum, item) => sum + (item.quantity * Number(item.sale_price || 0)), 0);
    let isButtonDisabled = cart.length === 0;
    let conditionMessage = '';

    if (store?.sale_condition_type === 'GREATER_THAN' && total > 0 && total <= store.sale_condition_amount) {
        isButtonDisabled = true;
        conditionMessage = `El total debe ser mayor a $${Number(store.sale_condition_amount).toFixed(2)}`;
    } else if (store?.sale_condition_type === 'LESS_THAN' && total >= store.sale_condition_amount) {
        isButtonDisabled = true;
        conditionMessage = `El total debe ser menor a $${Number(store.sale_condition_amount).toFixed(2)}`;
    }

    return (
        <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Typography variant="h5" gutterBottom>Ticket de Venta</Typography>
            <Divider />
            <List sx={{ flexGrow: 1, overflowY: 'auto' }}>
                {cart.length === 0 ? <ListItem><ListItemText primary="El carrito está vacío" /></ListItem> : cart.map(item => (
                    <ListItem key={item.id} secondaryAction={<IconButton edge="end" onClick={() => updateQuantity(item.id, -item.quantity)}><DeleteIcon /></IconButton>}>
                        <ListItemText primary={item.name} secondary={`$${Number(item.sale_price || 0).toFixed(2)}`} />
                        <Box sx={{ display: 'flex', alignItems: 'center', ml: 2 }}>
                            <IconButton size="small" onClick={() => updateQuantity(item.id, -1)}><RemoveCircleIcon fontSize="small" /></IconButton>
                            <Typography sx={{ mx: 1, minWidth: '2ch', textAlign: 'center' }}>{item.quantity}</Typography>
                            <IconButton size="small" onClick={() => updateQuantity(item.id, 1)}><AddCircleIcon fontSize="small" /></IconButton>
                        </Box>
                    </ListItem>
                ))}
            </List>
            <Divider />
            <Box sx={{ mt: 'auto', p: 2, borderTop: '1px solid rgba(0, 0, 0, 0.12)' }}>
                <Typography variant="h4" align="right">Total: ${total.toFixed(2)}</Typography>
                {conditionMessage && <Alert severity="warning" sx={{ mt: 1 }}>{conditionMessage}</Alert>}
                <Button variant="contained" color="primary" fullWidth sx={{ mt: 2, py: 1.5, fontSize: '1.1rem' }} disabled={isButtonDisabled} onClick={onProceedToPayment}>
                    Proceder al Pago
                </Button>
                <Button variant="outlined" color="secondary" fullWidth sx={{ mt: 1 }} onClick={onOpenCreditModal}>
                    Recibir Abono a Crédito
                </Button>
            </Box>
        </Box>
    );
};
export default Cart; // <-- EXPORTACIÓN POR DEFECTO